import { QueryEntity, EntityUIQuery } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { RecentNotificationsStore, RecentNotificationsState } from './recent-notifications.store';

@Injectable({
	providedIn: 'root'
})
export class RecentNotificationsQuery extends QueryEntity<RecentNotificationsState> {
	ui: EntityUIQuery<RecentNotificationsState['ui']>

	constructor(protected store: RecentNotificationsStore) {
		super(store);
	}
}